import React from 'react';
import { Stack, Button } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
    buttonContent: {
        margin: '8px',
    },
}));

const ButtonContainer = (props) => {
    const classes = useStyles();

    return (
        <Stack
            spacing={2}
            direction="row-reverse"
            className={classes.buttonContent}>
            <Button
                type="submit"
                variant="contained"
                onClick={props.handleClick ? props.handleClick : null}
                disabled={
                    props.disableButton != undefined
                        ? props.disableButton
                        : false
                }>
                {props.buttonText}
            </Button>
            <Button
                variant="outlined"
                onClick={props.handleCancel}
                disabled={
                    props.disableCancel != undefined 
                    ? props.disableCancel 
                    : (props.disableButton != undefined
                        ? props.disableButton
                        : false)
                }>
                Cancel
            </Button>
        </Stack>
    );
};
export default ButtonContainer;
